import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import { RealtorInfoDesktopContainer } from './RealtorInfoDesktopContainer';
import { RealtorInfoMobileContainer } from './RealtorInfoMobileContainer';

export function RealtorInfoContainer() {
  return (
    <>
      <Responsive desktop>
        <RealtorInfoDesktopContainer />
      </Responsive>
      <Responsive tablet phone>
        <RealtorInfoMobileContainer />
      </Responsive>
    </>
  );
}
